import React, { useState, useEffect } from "react";
import { Info, X } from "lucide-react";
import { useLang } from "@/context/LangContext";

const TR = {
  sk: { msg: 'Pre plne fungujúce push notifikácie si Tigik nainštaluj priamo z webu cez „Pridať na plochu" (PWA). Návod nájdeš nižšie na stránke.' },
  en: { msg: 'For fully working push notifications, install Tigik directly from the web via "Add to Home Screen" (PWA). Setup guide further down this page.' },
  cs: { msg: 'Pro plně fungující push notifikace si Tigik nainstaluj přímo z webu přes "Přidat na plochu" (PWA). Návod najdeš níže na stránce.' },
  de: { msg: 'Für voll funktionierende Push-Benachrichtigungen installiere Tigik direkt aus dem Web via "Zum Startbildschirm hinzufügen" (PWA). Anleitung weiter unten auf der Seite.' },
  pl: { msg: 'Aby powiadomienia push w pełni działały, zainstaluj Tigik bezpośrednio z sieci przez "Dodaj do ekranu głównego" (PWA). Instrukcja niżej na stronie.' },
  fr: {
  msg: "Pour des notifications push pleinement fonctionnelles, installe Tigik directement depuis le web via « Ajouter à l'écran d'accueil » (PWA). Le guide se trouve plus bas sur la page."
},
};

const STORAGE_KEY = "wb_push_playstore_notice_dismissed_v2";

/**
 * One-line info banner explaining that web-push notifications will be fully
 * reliable only once the Tigik Android app is live on Google Play.
 * Dismissible (state persisted in localStorage).
 */
export default function PushPlayStoreNotice({ compact = false }) {
  const { lang } = useLang();
  const tr = TR[lang] || TR.sk;
  const [dismissed, setDismissed] = useState(true);

  useEffect(() => {
    try {
      setDismissed(localStorage.getItem(STORAGE_KEY) === "1");
    } catch {
      setDismissed(false);
    }
  }, []);

  if (dismissed) return null;

  const dismiss = () => {
    try { localStorage.setItem(STORAGE_KEY, "1"); } catch {}
    setDismissed(true);
  };

  return (
    <div
      data-testid="push-playstore-notice"
      className={`flex items-start gap-2 border-l-2 border-blue-500/60 bg-blue-950/25 ${compact ? "px-2.5 py-1.5" : "px-3 py-2"} mb-3 text-[11px] text-blue-200/95 leading-relaxed`}
    >
      <Info className="w-3.5 h-3.5 mt-0.5 flex-shrink-0 text-blue-400" />
      <span className="flex-1">{tr.msg}</span>
      <button
        onClick={dismiss}
        data-testid="push-playstore-notice-dismiss"
        title="OK"
        className="text-blue-300/60 hover:text-blue-200 flex-shrink-0 -mt-0.5"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
